import { useField, Field } from 'vee-validate';


export default {
  __name: 'ImportantInformationField',
  props: {
    isRequired: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: 'Dolegliwości oraz ważne informacje dla Iekarza',
    },
    placeholder: {
        type: String,
        default:
            'Wpisz swoje dolegliwości, powód przyjmowania Ieku lub inne ważne informacje dla Iekarza do analizy wywiadu medycznego',
    },
    classes: {
        type: String,
        default: '',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const { value, errors, errorMessage } = useField('importantInformation');

const __returned__ = { props, value, errors, errorMessage, get useField() { return useField }, get Field() { return Field } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}